'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPayment$002dTerms$0024 from "./app.data.data_point_types$package$-Payment-Terms$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$() {
  this.aO5 = null;
  this.aOm = null;
  this.aO8 = null;
  this.aO9 = false;
  this.aOe = null;
  this.aOf = false;
  this.aOk = null;
  this.aOl = false;
  this.aO6 = null;
  this.aO7 = false;
  this.aOi = null;
  this.aOj = false;
  this.aOg = null;
  this.aOh = false;
  this.aOa = null;
  this.aOb = false;
  this.aOc = null;
  this.aOd = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ = this;
  this.aO5 = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPayment$002dTerms$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$();
  this.aOm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPayment$002dTerms$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$.prototype = $p;
$p.eR = (function() {
  return this.aO5;
});
$p.eO = (function() {
  return this.aOm;
});
$p.bW = (function() {
  if ((!this.aO9)) {
    this.aO8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aO9 = true;
  }
  return this.aO8;
});
$p.b9 = (function() {
  if ((!this.aOf)) {
    this.aOe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aOf = true;
  }
  return this.aOe;
});
$p.b3 = (function() {
  if ((!this.aOl)) {
    this.aOk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aOl = true;
  }
  return this.aOk;
});
$p.aG = (function() {
  if ((!this.aO7)) {
    this.aO6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aO7 = true;
  }
  return this.aO6;
});
$p.az = (function() {
  if ((!this.aOj)) {
    this.aOi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aOj = true;
  }
  return this.aOi;
});
$p.aY = (function() {
  if ((!this.aOh)) {
    this.aOg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aOh = true;
  }
  return this.aOg;
});
$p.afg = (function() {
  if ((!this.aOb)) {
    this.aOa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Payment Terms";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aOb = true;
  }
  return this.aOa;
});
$p.bNH = (function() {
  if ((!this.aOd)) {
    this.aOc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aOd = true;
  }
  return this.aOc;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$, "app.data.data_point_types$package$PaymentTermsForm$", ({
  Gd: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTermsForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Payment-Terms-Form$.js.map
